import Dinero from 'dinero.js';

export const getStringAsCurrency = (text, currencySymbol = '') => {
    if (!text && text !== '') return;

    let currency = Dinero({
        amount: 99,
        currency: 'EUR',
        precision: 0,
    }).toFormat();

    let symbol = currencySymbol || Dinero.defaultUserCurrencySymbol || '€';

    if (symbol === '') symbol = currency[0];

    if (symbol && symbol !== '€') {
        currency = currency.replace('€', symbol);
    }

    if (currency.indexOf(symbol) === 0) {
        return `${symbol} ${text}`;
    } else {
        // check if the character previous the symbol is a space to add it
        if (currency.length > 1 && /\s/.test(currency[currency.length - 2])) symbol = ` ${symbol}`;
        return `${text}${symbol}`;
    }
};
